type Entity = {
  value: number
}

export const assetsSum = (assets: Entity[]): number => {
  return assets.reduce((total, entity) => {
    return total + entity.value
  }, 0)
}
